import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { DownloadCloud } from "lucide-react";
import { api } from "../../lib/api";

const pct = (s) => (s && s.fga ? Math.round((s.fgm / s.fga) * 1000) / 10 : null);
const att = (s) => (s && s.fga != null ? s.fga : null);

// Fill Step 1 from a saved Shot Diet "Shot Profile" (inputs: three_overall / three_cs_* / three_off_dribble).
export function statsFromShotProfile(a, gamesPlayed) {
  const i = a.inputs || {};
  const three = i.three_overall;
  return {
    three_pt_pct: pct(three),
    three_pa_per_game: three?.fga && gamesPlayed ? Math.round((three.fga / gamesPlayed) * 10) / 10 : null,
    cs_att: att(i.three_cs_overall), cs_pct: pct(i.three_cs_overall),
    otd_att: att(i.three_off_dribble), otd_pct: pct(i.three_off_dribble),
    cs_uncontested_att: att(i.three_cs_unguarded), cs_uncontested_pct: pct(i.three_cs_unguarded),
    cs_contested_att: att(i.three_cs_guarded), cs_contested_pct: pct(i.three_cs_guarded),
    shot_diet_id: a.id,
  };
}

export function ShotProfilePull({ playerId, gamesPlayed, onPull }) {
  const [analyses, setAnalyses] = useState(null);
  const [pick, setPick] = useState("");
  useEffect(() => { api.shotDietAnalyses(playerId).then(rows => { setAnalyses(rows); setPick(rows[0]?.id || ""); }).catch(() => setAnalyses([])); }, [playerId]);
  if (analyses === null) return null;
  if (!analyses.length) return <span className="text-[10px] uppercase tracking-[0.2em] text-[#575757]" data-testid="se-pull-none">No Shot Profile yet</span>;
  const pull = () => {
    const a = analyses.find(x => x.id === pick) || analyses[0];
    onPull(statsFromShotProfile(a, gamesPlayed));
    toast.success("Pulled from Shot Profile");
  };
  return (
    <div className="flex items-center gap-1.5" data-testid="se-pull">
      {analyses.length > 1 && (
        <select value={pick} onChange={e => setPick(e.target.value)} className="bg-[#0f0f0f] border border-white/10 text-[10px] uppercase tracking-[0.15em] text-white px-2 py-1.5 focus:outline-none" data-testid="se-pull-select">
          {analyses.map(a => <option key={a.id} value={a.id}>{a.label || "Analysis"} · {new Date(a.created_at).toLocaleDateString()}</option>)}
        </select>
      )}
      <button type="button" onClick={pull} className="px-3 py-1.5 border border-[var(--org-accent)] text-[var(--org-accent)] text-[10px] uppercase tracking-[0.2em] font-bold flex items-center gap-1.5 hover:bg-[var(--org-accent)]/10" data-testid="se-pull-btn">
        <DownloadCloud className="w-3 h-3" /> Pull from Shot Profile
      </button>
    </div>
  );
}
